module.exports = __webpack_public_path__ + "static/media/15.7bd6f920.jpeg";